/* ARTLEAP — 作家のInstagram（プロフィール埋め込みの高さ合わせ）
   Instagram の埋め込みは親へ postMessage で {type:'MEASURE', details:{height}} を送る（2026-09-17 検証）。
   それを受けて iframe の高さを合わせる。届かなければ CSS の 600px のまま。 */
(function () {
  var frames = document.querySelectorAll('[data-ig-frame]');
  if (!frames.length) return;
  window.addEventListener('message', function (e) {
    if (!/(^|\.)instagram\.com$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
    if (!d || d.type !== 'MEASURE' || !d.details || !(d.details.height > 0)) return;
    frames.forEach(function (f) {
      if (f.contentWindow === e.source) f.style.height = Math.ceil(d.details.height) + 'px';
    });
  });
})();
